import * as S from "./styles";
import Car from "./assets/car.svg";
import Home from "./assets/home.svg";

import { useState } from "react";

import { useEffect } from "react";

import { IReport } from "interfaces/Report";
import { socket } from "hooks/useSocket";
import ReactTooltip from "react-tooltip";
import { Button } from "monk_ui";
import { useAuth } from "contexts/authContext";
import { HistoricItem } from "interfaces/Historic";

type CardProps = {
  occurrence: HistoricItem;
  reportClick: () => void;
};

export function HistoricCard({ occurrence, reportClick }: CardProps) {
  function formatDate(occurrenceDate: Date) {
    function addZero(i: string | number) {
      if (Number(i) < 10) {
        i = "0" + i;
      }
      return i;
    }
    const date = new Date(occurrenceDate);
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const dt = addZero(date.getDate());
    const hour = addZero(date.getHours());
    const minutes = addZero(date.getMinutes());
    const seconds = addZero(date.getSeconds());

    return (
      dt +
      "/" +
      month +
      "/" +
      year +
      " às " +
      hour +
      ":" +
      minutes +
      ":" +
      seconds
    );
  }

  function isPolicemanWorktype() {
    return occurrence.workType === "Policial";
  }

  function formatPoliceman() {
    return occurrence.attendantName ?? "Sem prestador";
  }

  function formatAddress() {
    return (
      occurrence.street +
      ", " +
      occurrence.number +
      " - " +
      occurrence.uf +
      " | CEP: " +
      occurrence.postalCode
    );
  }

  return (
    <S.CardContainer data-cy="occurrence-card">
      <>
        <S.CardHeader>
          <S.CardHeaderInfo>
            {occurrence.patrimonialType === 1 ? (
              <img src={Home} alt="occurrence-img" />
            ) : (
              <img src={Car} alt="occurrence-img" />
            )}
            <S.Description>
              <h2>Ocorrência</h2>
              <p data-cy="type-occurrence">
                {occurrence.patrimonialType === 1
                  ? "Estabelecimento"
                  : "Veículo"}
              </p>
              <p>{`Protocolo: ${occurrence.protocol}`}</p>
            </S.Description>
          </S.CardHeaderInfo>
          <S.BadgeContainer
            vehicleFound={occurrence?.findCoords && occurrence.findCoords.length! > 0}
            finished={occurrence.status === 'concluido'}
          >
            {occurrence?.patrimonialType === 2 && (
              <p
                className="badge found-info"
              >
                {occurrence?.findCoords?.length! > 0 ? 'ENCONTRADO' : 'NÃO ENCONTRADO'}
              </p>
            )}

            <p className="badge finished-info">
              {occurrence.status === 'concluido' ? 'FINALIZADA' : 'EM ANDAMENTO'}
            </p>
          </S.BadgeContainer>
        </S.CardHeader>

        <S.CardBody>
          <S.CardRow>
            <S.CardColumn>
              <S.CardItem>
                <p className="title">Criado em: </p>
                <h4 title="data">{formatDate(occurrence.createdAt)}</h4>
              </S.CardItem>
              <S.CardItem>
                <p className="title">Atendente</p>
                <h4 title={occurrence.attendantName} className="subtitle">
                  {occurrence.attendantName}
                </h4>
              </S.CardItem>

              <S.CardItem>
                <p className="title">Subcliente</p>
                <h4
                  title={
                    occurrence.superficialClientName
                  }
                  className="subtitle"
                >
                  {
                    occurrence.superficialClientName
                  }
                </h4>
              </S.CardItem>

              <S.CardItem>
                <p className="title">Prestador</p>
                <h4 title={formatPoliceman()} className="subtitle">
                  {formatPoliceman()}
                </h4>
              </S.CardItem>
            </S.CardColumn>
            <S.CardColumn>
              <S.CardItem>
                <p className="title">Boletim</p>
                <h4
                  title={occurrence.numberBO || "Sem Boletim"}
                  className="subtitle boSubtitle"
                >
                  {occurrence.numberBO || "Sem Boletim"}
                </h4>
              </S.CardItem>

              <S.CardItem>
                <p className="title">Cliente</p>
                <h4
                  title={
                    occurrence.clientName
                  }
                  className="subtitle"
                >
                  {
                    occurrence.clientName
                  }
                </h4>
              </S.CardItem>

              <S.CardItem>
                <p className="title">Endereço</p>

                <h4 title={formatAddress()} className="subtitle">
                  {formatAddress()}
                </h4>
              </S.CardItem>

              <S.CardItem>
                <p className="title">Tipo do prestador</p>

                <h4 className="subtitle">
                  {isPolicemanWorktype() ? "Pronta-resposta" : "Assistente"}
                </h4>
              </S.CardItem>
            </S.CardColumn>
          </S.CardRow>
        </S.CardBody>

        <footer className="footer">
          <Button
            title="Ver mais detalhes"
            onClick={reportClick}
            size="large"
            background="#D6A606"
          />
        </footer>
      </>
    </S.CardContainer>
  );
}
